import { render, staticRenderFns } from "./PosBadgeTest.vue?vue&type=template&id=18eaea64&scoped=true"
import script from "./PosBadgeTest.vue?vue&type=script&lang=js"
export * from "./PosBadgeTest.vue?vue&type=script&lang=js"
import style0 from "./PosBadgeTest.vue?vue&type=style&index=0&id=18eaea64&prod&scoped=true&lang=css"
import style1 from "./PosBadgeTest.vue?vue&type=style&index=1&id=18eaea64&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18eaea64",
  null
  
)

export default component.exports